var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.list
    ? _c(
        "section",
        {
          directives: [
            {
              name: "htmlclass",
              rawName: "v-htmlclass",
              value: { "past-orders-open": _vm.value },
              expression: '{"past-orders-open": value}',
            },
          ],
          staticClass: "past-orders",
        },
        [
          _c("div", { staticClass: "wrapper wrapper--tablet" }, [
            _c("div", { staticClass: "control" }, [
              _c(
                "div",
                { staticClass: "control__section control__section--past" },
                [
                  _c("h2", [_vm._v("Past Orders")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "control__grid control__scroll" },
                    _vm._l(_vm.list, function (item) {
                      return _c("OrderBox", {
                        key: item.id,
                        attrs: { order: item },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("changestate", item)
                          },
                        },
                      })
                    }),
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "control__past-orders-button",
                  attrs: { type: "button" },
                  on: { click: _vm.onCloseButton },
                },
                [_vm._v("Back to current Orders")]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }